export const NEXT_BUTTON_CLASS_NAME = 'HighlightClipScrollerControls__next';
export const PREV_BUTTON_CLASS_NAME = 'HighlightClipScrollerControls__prev';
